const TextSubpage = () => {
  return (
    <div>
      <h1>Text Subpage</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed pulvinar neque a risus
        elementum, at fermentum elit euismod. Proin vehicula, nulla sit amet facilisis luctus, mi
        elit mollis neque, quis tincidunt nulla risus nec dolor. Aenean quis viverra diam, a auctor
        nunc. Vivamus fermentum diam sed augue bibendum, in pharetra elit auctor. In in arcu vitae
        mi fermentum placerat. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
        posuere cubilia curae; Curabitur ac velit diam.
      </p>
      <p>
        Cras ultricies finibus congue. Sed ut bibendum ligula, id scelerisque velit. Vivamus
        vulputate risus ac leo consequat, sed euismod diam fermentum. Phasellus fermentum risus sed
        neque fermentum, eget dapibus lorem varius. Etiam in sapien id urna lacinia posuere. Nulla
        facilisi.
      </p>
    </div>
  );
};

export default TextSubpage;
